import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="border-t border-[#DFE5DC] bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-[2fr_1fr_1fr_1fr]">
        <div>
          <p className="font-display text-3xl md:text-4xl mb-4 tracking-tight text-[#0F1F1A]">
            Trusted <span className="italic text-[#0C6B4F]">Financial Hub</span>
          </p>
          <p className="text-[#5C6B62] text-sm leading-relaxed max-w-xs">
            An independent comparison service — helping you evaluate vetted providers across lending, credit building and identity protection.
          </p>
        </div>
        <div>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#8A978D] mb-5">Explore</p>
          <div className="flex flex-col gap-3 text-sm">
            <Link to="/personal-loan" data-testid="footer-link-personal-loan" className="text-[#5C6B62] hover:text-[#0C6B4F] transition-colors duration-300">Personal Loan</Link>
            <Link to="/identity-protection" data-testid="footer-link-credit-health" className="text-[#5C6B62] hover:text-[#0C6B4F] transition-colors duration-300">Credit Health</Link>
            <Link to="/credit-builder" data-testid="footer-link-credit-builder" className="text-[#5C6B62] hover:text-[#0C6B4F] transition-colors duration-300">Credit Builder</Link>
            <Link to="/how-it-works" data-testid="footer-link-how-it-works" className="text-[#5C6B62] hover:text-[#0C6B4F] transition-colors duration-300">How It Works</Link>
          </div>
        </div>
        <div>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#8A978D] mb-5">Legal</p>
          <div className="flex flex-col gap-3 text-sm">
            <Link to="/disclosures#advertising" data-testid="footer-link-advertising" className="text-[#5C6B62] hover:text-[#0C6B4F] transition-colors duration-300">Advertising Disclosure</Link>
            <Link to="/privacy" data-testid="footer-link-privacy" className="text-[#5C6B62] hover:text-[#0C6B4F] transition-colors duration-300">Privacy Policy</Link>
            <Link to="/disclosures#terms" data-testid="footer-link-terms" className="text-[#5C6B62] hover:text-[#0C6B4F] transition-colors duration-300">Terms of Service</Link>
          </div>
        </div>
        <div>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#8A978D] mb-5">Reach Us</p>
          <div className="flex flex-col gap-3 text-sm font-mono2 text-[#5C6B62]">
            <span>info@trustedfinancialhub.com</span>
          </div>
        </div>
      </div>
      <div className="border-t border-[#DFE5DC]">
        <div className="max-w-7xl mx-auto px-6 py-5">
          <p className="text-[11px] leading-relaxed text-[#8A978D] max-w-5xl" data-testid="footer-compact-disclosures">
            Trusted Financial Hub is an independent comparison service — not a lender or credit provider. Loans from third-party providers are intended as short-term solutions; approval, rates and terms are determined solely by the provider you choose. Providers may perform credit checks with your consent. We may receive compensation from listed providers, which can influence placement — it never influences our editorial standards.{" "}
            <Link to="/disclosures" className="underline hover:text-[#0C6B4F] transition-colors duration-300">Full disclosures</Link>
          </p>
        </div>
      </div>
      <div className="border-t border-[#DFE5DC]">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between gap-3">
          <p className="font-mono2 text-xs text-[#8A978D]">© 2026 Trusted Financial Hub. All rights reserved.</p>
          <p className="font-mono2 text-xs text-[#8A978D]">A comparison service — not a lender or provider.</p>
        </div>
      </div>
    </footer>
  );
}
